import React from 'react';
import ReactDOM from 'react-dom/client';
import moment from 'moment/min/moment-with-locales';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import create from './redux/store';
import Utils from './utils/utils';
import abpUserConfigurationService from './services/abpUserConfigurationService';

const { abp } = window;
Utils.setLocalization();
abpUserConfigurationService.getAllCustom().then((data) => {  
  Utils.extend(true, abp, data.data.result);
  abp.clock.provider = Utils.getCurrentClockProvider(
    data.data.result.clock.provider
  );

  // moment.locale(abp.localization.currentLanguage.name);
  moment.locale('en-AU');

  // if (abp.clock.provider.supportsMultipleTimezone) {
  //   momentTz.tz.setDefault(abp.timing.timeZoneInfo.iana.timeZoneId);
  // }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={create()}>
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
